import React, { useContext, Component } from "react";
import { InView } from "react-intersection-observer";
import VisibilitySensor from "react-visibility-sensor";
import { IoPlayCircle } from "react-icons/io5";
import "styled-components/macro";

import { ModalBetaSignupContext } from "../Contexts/ModalBetaSignup";
import MockKeysAndBrowser from "../MockKeysAndBrowser";
import CardCompanyValues from "../CardCompanyValues";
import StickyVideoFeatureTriad from "../StickyVideoFeatureTriad";
import BonusFeaturesTileCAM from "../BonusFeaturesTileCAM";
import BonusFeaturesTilePersonalizedUI from "../BonusFeaturesTilePersonalizedUI";
import BonusFeaturesFOSS from "../BonusFeaturesFOSS";
import BonusFeaturesZeroBranding from "../BonusFeaturesZeroBranding";
import BonusFeaturesFullyMouseCapable from "../BonusFeaturesFullyMouseCapable";
import Footer from "../Footer";
import imgLogoWBetaBadge from "../images/logo-w-beta-badge-162x28.svg";
import imgDataPrivacyOval from "../images/data-privacy-oval.svg";
import imgOpenSourceOval from "../images/open-source-oval.svg";
import imgExitPlatformOval from "../images/exit-platform-oval.svg";
import Navbar from "../Navbar";
import CardRSSSource from "../CardRSSSource";
import CallToAction from "../CallToAction";
import ButtonWatchTrailer from "../ButtonWatchTrailer";
import TrailerVideoModal from "../TrailerVideoModal";
import sizes from "../utils/sizes";
import sampleRssSources from "../utils/sample-rss-sources";
import imgNoise from "../images/noise.png";
import ModalBetaSignup from "../ModalBetaSignup";
import guessMyDevice from "../utils/guess-my-device";
import NavbarMobile from "../NavbarMobile";
import BackgroundImage from "../BackgroundImage";
import MobileFeatureCardMouseDevice from "../images/MobileFeatureCardMouseDevice.svg";
import MobileFeatureCardCAM from "../images/MobileFeatureCardCAM.svg";
import MobileFeatureCardNonBrandedExperience from "../images/MobileFeatureCardNonBrandedExperience.svg";
import MobileFeatureCardOpenSource from "../images/MobileFeatureCardOpenSource.svg";
import MobileFeatureCardThemingMods from "../images/MobileFeatureCardThemingMods.svg";

class MarketingLanding extends Component {
  state = {
    isVizVideoSection: false,
    isTrailerVideoOpen: false,
    shouldAllowCTABannerToMount: false,
    isHeroCTAVisible: false,
    isFooterVisible: false,
  };

  device = guessMyDevice();

  initialHeightDimensions = window.innerHeight - 117

  render() {
    const {
      isVizVideoSection,
      isTrailerVideoOpen,
      shouldAllowCTABannerToMount,
      isHeroCTAVisible,
      isFooterVisible,
      playingStickyVideoFeatureTriad,
    } = this.state;
    const {
      isModalBetaSignupVisible,
      showModalBetaSignup,
      hideModalBetaSignup,
    } = this.props.context;

    return (
      <div
        css={`
          overflow: hidden;
        `}
      >
        {/* Inter ATF content */}
        <div
          css={`
            margin: 0 auto;
            height: 100vh;
            max-height: 1080px;
            overflow: hidden;
            background: hsl(240 11% 95% / 1);
            position: relative;
          `}
        >
          {this.device !== "mobile" ? (
            <Navbar showModalBetaSignup={showModalBetaSignup} />
          ) : (
            <NavbarMobile showModalBetaSignup={showModalBetaSignup} />
          )}
          {/* Inter */}
          <div
            css={`
              z-index: 3;
              position: relative;
              display: ${this.device !== "mobile" ? "block " : "flex"};
              flex-direction: ${this.device !== "mobile" ? "auto" : "column"};
              justify-content: ${this.device !== "mobile"
                ? "flex-start"
                : "space-between"};
              height: ${this.device !== "mobile"
                ? "auto"
                : `${this.initialHeightDimensions}px`};
              margin: ${this.device !== "mobile"
                ? "110px auto 0"
                : "37px auto 0"};
              padding: 0 ${sizes[this.device].paddingX}px;
              max-width: ${sizes[this.device].landscape}px;
              overflow: hidden;
            `}
          >
            <div>
              {/* Main marketing slogan */}
              <h1
                css={`
                  margin: 0 auto 13px;
                  line-height: ${this.device !== "mobile" ? "130%" : "124%"};
                  font-size: ${this.device !== "mobile" ? "43px" : "28px"};
                  font-weight: ${this.device !== "mobile" ? "700" : "600"};
                  letter-spacing: -0.3px;
                  text-align: center;
                `}
              >
                The privacy-minded RSS reader
                {this.device !== "mobile" ? <br /> : ' '}
                you control using a keyboard.
              </h1>

              {/* Secondary marketing slogan */}
              <div
                css={`
                  width: ${this.device !== "mobile" ? "597px" : "260px"};
                  margin: ${this.device !== "mobile" ? "19px" : "-9px"} auto 0;
                  padding: 0 0 20px;
                  text-align: center;
                  color: hsl(240 6% 47% / 1);
                  line-height: 130%;
                  letter-spacing: 0.2px;
                  font-size: ${this.device !== "mobile" ? "22px" : "14px"};
                  font-weight: 400;
                `}
              >
                Open source. Free forever. Designed for RSS power users,
                knowledge workers, and IT professionals.
              </div>
            </div>

            {/* CTA Button, and Watch Trailer Button */}
            <div
              css={`
                display: flex;
                flex-direction: ${this.device !== "mobile"
                  ? "column"
                  : "column-reverse"};
                margin: 0 0 20px;
              `}
            >
              <VisibilitySensor
                intervalDelay={500}
                onChange={this.handleVizHeroCTA}
              >
                <div
                  css={`
                    display: flex;
                    justify-content: center;
                    margin: ${this.device !== "mobile" ? "20px 0 0" : "0"};
                  `}
                >
                  <CallToAction
                    onClick={showModalBetaSignup}
                    buttonTextLeading="Join the Beta"
                    buttonTextSupporting="Onboarding in September 2024"
                  />
                </div>
              </VisibilitySensor>

              <div
                css={`
                  /* display: ${this.device !== "mobile" ? "flex" : "none"}; */
                  display: flex;
                  justify-content: center;
                  margin: 10px auto;
                  width: 100%;
                  max-width: ${sizes[this.device].landscape}px;
                  overflow: hidden;
                  text-align: center;
                `}
              >
                <ButtonWatchTrailer
                  handleOpenTrailerVideo={this.handleOpenTrailerVideo}
                />
              </div>
            </div>
          </div>
          <MockKeysAndBrowser deviceWidth={sizes[this.device].landscape} />
        </div>

        {/* Inter 3 Autoplaying Videos*/}
        <InView as="div" threshold={0.15} onChange={this.handleVizVideoSection}>
          <div
            css={`
              display: ${this.device !== "mobile" ? "block" : "none"};
              z-index: 1;
              position: relative;
              padding: ${this.device !== "mobile" && this.device !== 'tablet'
                ? "130px 0px 110px"
                : "60px 0px 60px"};
              background: hsl(240deg 10% 94.5%) url(${imgNoise}) repeat;
              background-size: 361px 370px;
              border-top: 1px solid hsl(240 11% 90% / 1);
              &:after {
                /* Set the new background color */
                /* background-color: #1a1a2a; */
                /* Render the pseudo element */
                content: "";
                /* Cover the entire page with the pseudo element */
                position: absolute;
                top: 3px;
                bottom: 0;
                left: 0;
                right: 0;
                /* Render the new background color beneath the page content */
                z-index: -1;
                opacity: ${isVizVideoSection ? 1 : 0};
                /* Animate opacity changes */
                transition: opacity 1000ms;
              }
            `}
          >
            <div>
              <div
                css={`
                  margin: 0 auto;
                  width: 435px;
                  text-align: center;
                  color: #02021d;
                  text-align: center;
                  font-family: Inter;
                  line-height: ${this.device !== "mobile" ? "130%" : "124%"};
                  font-size: ${this.device !== "mobile" ? "30px" : "28px"};
                  font-weight: ${this.device !== "mobile" ? "600" : "600"};
                  letter-spacing: -0.3px;
                `}
              >
                Complete keyboard coverage for interacting with RSS feeds.
              </div>
            </div>
            <StickyVideoFeatureTriad
              title="Navigate"
              description="Maneuver with ease across your feeds and articles."
              videoSrc="video/coretext-shorts/nav.mp4"
              vizThreshold={1}
              desktopWidth={sizes[this.device].landscape}
              desktopPaddingX={sizes[this.device].paddingX}
            />
            <StickyVideoFeatureTriad
              title="Reading"
              description="Focus and expand articles for reading."
              videoSrc="video/coretext-shorts/read.mp4"
              vizThreshold={1}
              desktopWidth={sizes[this.device].landscape}
              desktopPaddingX={sizes[this.device].paddingX}
            />
            <StickyVideoFeatureTriad
              title="Management"
              description="Add feeds, delete them, or move them into folders."
              videoSrc="video/coretext-shorts/mgmt.mp4"
              vizThreshold={1}
              desktopWidth={sizes[this.device].landscape}
              desktopPaddingX={sizes[this.device].paddingX}
            />
            {/* <div
              css={`
                margin: 0 auto;
                width: 100%;
                padding: 0 ${sizes[this.device].paddingX}px;
                max-width: ${sizes[this.device].landscape}px;
                overflow: hidden;
                color: hsl(240 10% 35% / 1);
                line-height: 130%;
                letter-spacing: 0.2px;
                font-size: 16px;
                font-weight: 300;
              `}
            >
              <a
                href="/user-manual"
                css={`
                  display: inline-flex;
                  align-items: center;
                  text-decoration: none;
                  padding: 8px 17px;
                  line-height: 16px;
                  border-radius: 90px;
                  color: #9090ac;
                  font-weight: 400;
                  transition: filter 150ms ease-out;
                  background-color: hsl(240 12% 92% / 1);
                  &:hover {
                    filter: brightness(99%);
                  }
                `}
              >
                Read the&nbsp;<span css={`font-style: oblique;`}>User Manual</span>
                <IoBook
                  alt="icon"
                  css={`
                    margin-left: 15px;
                    width: 25px;
                    height: 25px;
                    color: #b0b0c9;
                  `}
                />
              </a>
            </div> */}
          </div>
        </InView>

        {/* Inter Featured Cards */}
        <div
          css={`
            position: relative;
            border-top: 1px solid #e3e3e3;
          `}
        >
          <div
            css={`
              z-index: -1;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            `}
          />
          <div
            css={`
              width: ${sizes[this.device].landscape}px;
              overflow: hidden;
              margin: 0 auto;
              padding: ${this.device !== "mobile" && this.device !== 'tablet'
                ? "130px 0px 110px"
                : "60px 0px 60px"};`}
          >
            <div>
              <div
                css={`
                  color: #02021d;
                  text-align: center;
                  font-family: Inter;
                  line-height: ${this.device !== "mobile" ? "130%" : "124%"};
                  font-size: ${this.device !== "mobile" ? "30px" : "28px"};
                  font-weight: ${this.device !== "mobile" ? "600" : "600"};
                  letter-spacing: -0.3px;
                `}
              >
                Next-generation{this.device === "mobile" && <br />} RSS features.
              </div>
            </div>
            {/* For Desktop */}
            <div
              css={`
                display: ${this.device !== "mobile" && this.device !== "tablet" ? "block" : "none"};
              `}
            >
              <div
                css={`
                  display: flex;
                  flex-direction: ${this.device !== "mobile"
                    ? "row"
                    : "column"};
                  gap: 16px;
                  justify-content: space-between;
                  margin: 60px 0 0;
                `}
              >
                {/* 1st "Mouse Infinite" */}
                <BonusFeaturesFullyMouseCapable />
                {/* 2nd "C.A.M." */}
                <BonusFeaturesTileCAM />
              </div>
              {/* 3rd "Personalized UI" */}
              <BonusFeaturesTilePersonalizedUI />
              <div
                css={`
                  display: flex;
                  gap: 16px;
                  justify-content: space-around;
                `}
              >
                <BonusFeaturesFOSS />
                <BonusFeaturesZeroBranding />
              </div>
            </div>
            {/* For Mobile + Tablet */}
            <div
              css={`
                display: ${this.device !== "mobile" && this.device !== "tablet" ? "none" : "flex"};
                flex-direction: ${this.device === "mobile" ? "column" : "row"};
                flex-wrap: ${this.device === "mobile" ? "nowrap" : "wrap"};
                gap: 45px;
                margin: ${this.device === "mobile" ? "40px 0 0" : this.device === 'tablet' ? '60px 0 0' : 'auto'};
              `}
            >
              {/* MOUSE DEVICE  */}
              <BackgroundImage
                imgSrc={MobileFeatureCardMouseDevice}
                width={this.device === 'mobile' ? 320 : 340}
                height={this.device === 'mobile' ? 359.5294117647 : 382}
              />
              {/* CAM  */}
              <BackgroundImage
                imgSrc={MobileFeatureCardCAM}
                width={this.device === 'mobile' ? 320 : 340}
                height={this.device === 'mobile' ? 359.5294117647 : 382}
              />
              {/* THEMING+MODS  */}
              <BackgroundImage
                imgSrc={MobileFeatureCardThemingMods}
                width={this.device === 'mobile' ? 320 : 340}
                height={this.device === 'mobile' ? 359.5294117647 : 382}
              />
              {/* OPEN SOURCE  */}
              <BackgroundImage
                imgSrc={MobileFeatureCardOpenSource}
                width={this.device === 'mobile' ? 320 : 340}
                height={this.device === 'mobile' ? 359.5294117647 : 382}
              />
              {/* NON-BRANDED UX  */}
              <div css={`
                display: ${this.device === 'tablet' ? 'none' : 'block'}
              `}>
                <BackgroundImage
                  imgSrc={MobileFeatureCardNonBrandedExperience}
                  width={this.device === 'mobile' ? 320 : 340}
                  height={this.device === 'mobile' ? 359.5294117647 : 382}
                /></div>
            </div>
          </div>
        </div>

        {/* Inter Company Values */}
        <div
          css={`
            background-color: hsl(240 20% 98% / 1);
            padding: ${this.device !== "mobile" && this.device !== 'tablet'
              ? "130px 0px 110px"
              : "60px 0px 60px"};
            box-shadow: 0 -8px 10px 0 hsl(0deg 0% 0% / 1.18%);
          `}
        >
          <div
            css={`
              margin: ${this.device !== "mobile" ? "unset" : "0 auto"};
              width: ${this.device !== "mobile" ? "unset" : "70%"};
              text-align: center;
              color: #02021d;
              text-align: center;
              font-family: Inter;
              line-height: ${this.device !== "mobile" ? "130%" : "124%"};
              font-size: ${this.device !== "mobile" ? "30px" : "28px"};
              font-weight: ${this.device !== "mobile" ? "600" : "600"};
              letter-spacing: -0.3px;
            `}
          >
            Customer first and privacy-focused.
          </div>
          <div
            css={`
              margin: 5px auto 0;
              padding: ${this.device !== "mobile" ? "0" : "0 30px"};
              width: ${this.device !== "mobile" ? "567px" : "unset"};
              text-align: center;
              color: hsl(240 6% 47% / 1);
              line-height: 130%;
              letter-spacing: 0px;
              font-size: ${this.device !== "mobile" ? "18px" : "14px"};
              font-weight: 400;
            `}
          >
            We're committed to offering the highest levels of customer-centric
            user policies when compared to our competitors.
          </div>
          <div
            css={`
              margin: ${this.device !== "mobile" ? "50px auto 0" : "0 auto 0"};
              display: flex;
              flex-direction: ${this.device !== "mobile" ? "row" : "column"};
              justify-content: space-evenly;
              width: ${sizes[this.device].landscape}px;
              overflow: hidden;
            `}
          >
            <CardCompanyValues
              imgSrc={imgDataPrivacyOval}
              title="Data Handling"
              // blurb="As great as it is to offer you a keyboard-driven RSS reader, it's actually far more important for us to be good custodians of your personal data. As a bootstrapped SaaS app, we really mean it when we say that we only collect and store the bare minimum data from our customers."
              blurb="Customer data is never sold, or mined for behaviorial insights. Customers maintain total ownership over their data."
            />
            <CardCompanyValues
              imgSrc={imgExitPlatformOval}
              title="Exit Anytime"
              // blurb="Aaron Swartz envisioned RSS as a way to unshackle the internet from Big Tech content silos, and re-establish more direct relationships between publishers, and readers. We honor Aaron's legacy by extending the promise that paid & free customers will be able to exit our platform at any time by exporting their OPML file."
              blurb="Free and paid customers can export their OMPL file, delete their account, and exit the platform at any time."
            />
            <CardCompanyValues
              imgSrc={imgOpenSourceOval}
              title="Open Source"
              blurb="Long-Term Support releases available for customers that prefer to host their own instance. Available early-2025."
            // blurb="We are going to follow the business model that popular projects, like Ubuntu, have used with great success. Our Long-Term Support (LTS) release will be open source, allowing anyone to self-host their own instance of CoreText. Our cloud managed version will be offered under a paid subscription model, and run a forked closed-source codebase with bleeding edge features and improvements."
            />
          </div>
        </div>

        {/* Inter RSS Sources */}
        <div
          css={`
            z-index: 1;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: hsl(240 20% 98% / 1);
            padding: ${this.device !== "mobile" && this.device !== 'tablet'
              ? "130px 0px 110px"
              : "60px 0px 60px"};

            border-top: 1px solid hsl(240 10% 91% / 1);
          `}
        >
          <div
            css={`
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 2px;
              align-self: stretch;
            `}
          >
            <div
              css={`
                margin: ${this.device !== "mobile" && this.device !== 'tablet' ? "unset" : "0 auto"};
                width: ${this.device !== "mobile" && this.device !== 'tablet' ? "unset" : "70%"};
                text-align: center;
                color: #02021d;
                text-align: center;
                font-family: Inter;
                line-height: ${this.device !== "mobile" && this.device !== 'tablet' ? "103%" : "124%"};
                font-size: ${this.device !== "mobile" && this.device !== 'tablet' ? "30px" : "28px"};
                font-weight: ${this.device !== "mobile" && this.device !== 'tablet' ? "600" : "600"};
                letter-spacing: -0.3px;
              `}
            >
              Works with any RSS/Atom feed.
            </div>
            <div
              css={`
                margin: 5px auto 0;
                padding: ${this.device !== "mobile" && this.device !== 'tablet' ? "0" : "0 30px"};
                width: ${this.device !== "mobile" && this.device !== 'tablet' ? "567px" : "unset"};
                text-align: center;
                color: hsl(240 6% 47% / 1);
                line-height: 130%;
                letter-spacing: 0px;
                font-size: ${this.device !== "mobile" && this.device !== 'tablet' ? "18px" : "14px"};
                font-weight: 400;
              `}
            >
              Including popular platforms that don't have official RSS feeds
            </div>
            <div
              css={`
                display: flex;
                flex-direction: row;
                flex-shrink: 0;
                flex-wrap: wrap;
                align-items: flex-start;
                align-content: flex-start;
                margin: ${this.device !== "mobile" && this.device !== 'tablet' ? "50px 0" : "50px 0 0"};
                width: ${this.device !== "mobile" && this.device !== 'tablet'
                  ? 1024
                  : sizes[this.device].landscape}px;
                gap: 1px;
                border-radius: 10px;
                overflow: hidden;
                box-shadow: 0px 0px 0px 1px hsl(0deg 0% 0% / 5%);
                background: hsl(0deg 0% 0% / 2%);
              `}
            >
              {sampleRssSources.map((x, idx) => (
                <CardRSSSource
                  key={idx}
                  imgSrc={x.imgSrc}
                  name={x.name}
                  url={x.url}
                  imgWidth={this.device !== "mobile" && this.device !== 'tablet' ? 40 : 25}
                  imgHeight={this.device !== "mobile" && this.device !== 'tablet' ? 40 : 25}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Inter Trailer Video */}
        <div
          css={`
            padding: ${this.device !== "mobile" && this.device !== 'tablet'
              ? "100px 0px"
              : "60px 0px 90px"};
            border-top: 1px solid hsl(240 10% 91% / 1);
            background-color: hsl(240 20% 98% / 1);
          `}
        >
          <div
            css={`
              display: flex;
              flex-direction: ${this.device !== "mobile" && this.device !== 'tablet'
                ? "row"
                : "column-reverse"};
              justify-content: center;
              margin: 0 auto;
              width: 100%;
              padding: 0 ${sizes[this.device].paddingX}px;
              width: ${sizes[this.device].landscape}px;
              overflow: hidden;
            `}
          >
            <div
              css={`
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: ${this.device !== "mobile" && this.device !== 'tablet' ? "20px" : "15px 0 0"};
                text-align: ${this.device !== "mobile" && this.device !== 'tablet' ? "unset" : "center"};
              `}
            >
              <h1
                css={`
                  margin: 0 0 10px;
                  line-height: 97%;
                  width: ${this.device !== "mobile" && this.device !== 'tablet' ? "662px" : "unset"};
                  font-size: 31px;
                  font-weight: bold;
                  font-family: Inter, sans-serif;
                `}
              >
                <div
                  css={`
                    font-size: ${this.device !== "mobile" && this.device !== 'tablet' ? "16px" : "14px"};

                    letter-spacing: 0.3px;
                    font-weight: 600;
                    color: #5d5db1;
                  `}
                >
                  Playback time 2:50
                </div>
                <div
                  css={`
                    margin: 0 0 0 1px;
                    color: #02021d;
                    font-family: Inter;
                    font-size: ${this.device !== "mobile" && this.device !== 'tablet' ? "30px" : "28px"};
                    font-weight: 600;
                    letter-spacing: -0.3px;
                    line-height: ${this.device !== "mobile" && this.device !== 'tablet' ? "130%" : "unset"};
                  `}
                >
                  Watch the trailer
                </div>
              </h1>
              <div
                css={`
                  font-size: 16px;
                  margin: ${this.device === "desktop" ? "-7px 0px 0px" : "-7px auto 0px"};
                  width: ${this.device === "desktop" ? "80%" : this.device === 'mobile' ? 'unset' : this.device === 'tablet' ? '50%' : '100%'};
                  line-height: 138%;
                  color: hsl(240 10% 35% / 1);
                  -webkit-font-smoothing: antialiased;
                  -moz-osx-font-smoothing: grayscale;
                  font-weight: 500;
                `}
              >
                See just how easy it is to navigate, read, and manage all of
                your RSS feeds with a sensible set of keyboard shortcuts.
              </div>
            </div>
            <div
              css={`
                position: relative;
                min-width: ${this.device !== "mobile" && this.device !== 'tablet' ? "558px" : "unset"};
              `}
            >
              <video
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                width="100%"
                src="video/visual-teaser/one.mp4"
                css={`
                  border-radius: 10px;
                  overflow: hidden;
                  /* box-shadow: 7px 1px 18px 5px #00000026; */
                `}
              />
              <div
                css={`
                  position: absolute;
                  top: 0px;
                  display: flex;
                  flex-direction: column-reverse;
                  width: 100%;
                  height: 100%;
                `}
              >
                <button
                  onClick={this.handleOpenTrailerVideo}
                  css={`
                    cursor: pointer;
                    /* position: absolute;
                    top: 301px;
                    left: 176px; */
                    display: flex;
                    padding: ${this.device !== "mobile"
                      ? "7px 10px 7px 14px"
                      : "4px 4px 4px 12px"};
                    margin: 0 auto 22px;
                    text-align: center;
                    line-height: 24px;
                    font-size: 16px;
                    font-weight: 600;
                    color: #ffffff;
                    background: hsl(0deg 0% 100% / 10%);
                    border: 2px solid #ffffff2e;
                    backdrop-filter: blur(3px);
                    border-radius: 40px;
                    box-shadow: 7px 1px 18px 5px #00000026;
                    font-family: Inter, Arial, sans-serif;
                    :hover {
                      background: hsl(0deg 0% 100% / 30%);
                      border: 2px solid #ffffff2e;
                    }
                    :focus {
                      background: hsl(0deg 0% 100% / 10%);
                      outline: none;
                      box-shadow: none;
                      border: 2px solid #ffffff2e;
                    }
                  `}
                >
                  <div
                    css={`
                    display: ${this.device !== "mobile" ? "block" : "none"}
                      margin-right: 5px;
                    `}
                  >
                    Watch the trailer
                  </div>
                  <IoPlayCircle
                    css={`
                      width: 25px;
                      height: 25px;
                      margin: 0 0 0 7px;
                    `}
                  />
                </button>
              </div>
              <TrailerVideoModal
                isTrailerVideoOpen={isTrailerVideoOpen}
                handleCloseTrailerVideo={this.handleCloseTrailerVideo}
                desktopWidth={sizes[this.device].landscape}
              />
            </div>
          </div>
        </div>

        <VisibilitySensor
          intervalDelay={500}
          partialVisibility
          onChange={this.handleVizFooter}
        >
          <Footer logoScrollsToTop showModalBetaSignup={showModalBetaSignup} />
        </VisibilitySensor>
        <ModalBetaSignup
          isVisible={isModalBetaSignupVisible}
          hideModalBetaSignup={hideModalBetaSignup}
        />

        {/* Fixed CTA Banner */}
        {shouldAllowCTABannerToMount ? (
          <div
            css={`
              z-index: ${!isHeroCTAVisible && !isFooterVisible ? 3 : -1};
              position: fixed;
              top: 0;
              display: ${this.device !== "mobile" ? "block" : "none"};
              width: 100vw;
              background-color: hsl(240 12% 98.7% / 1);
              outline: 1px solid hsl(0 0% 94% / 1);
              box-shadow: 0px -10px 15px 0px hsl(0deg 0% 0% / 25%);
              opacity: ${!isHeroCTAVisible && !isFooterVisible ? 1 : 0};
              transform: translateY(
                ${!isHeroCTAVisible && !isFooterVisible ? "0px" : "30px"}
              );
              transition: transform 150ms ease-out, opacity 200ms ease-out;
              transition: ${!isHeroCTAVisible && !isFooterVisible
                ? "opacity 250ms ease-out, transform 100ms ease-out"
                : "opacity 200ms ease-out, transform 100ms ease-out, z-index 1ms 300ms ease-out"};
            `}
          >
            <div
              css={`
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 0 auto;
                padding: 9px 30px;
                width: ${sizes[this.device].landscape}px;
                overflow: hidden;
              `}
            >
              <div>
                <span
                  onClick={this.scrollToTop}
                  href="/"
                  css={`
                    display: inline-block;
                    width: 162px;
                    height: 28px;
                    background: url(${imgLogoWBetaBadge}) no-repeat;
                    background-size: 162px 28px;
                    text-decoration: none;
                    transform: scale(1);
                    opacity: 1;
                    transition: transform 80ms ease-out;
                    cursor: pointer;
                    &:hover {
                      opacity: 0.8;
                      /* transform: scale(1.007); */
                    }
                    &:active,
                    &:focus {
                      opacity: 1;
                      transform: scale(1);
                      outline: none;
                    }
                  `}
                >
                  &nbsp;
                </span>
              </div>
              <CallToAction
                onClick={showModalBetaSignup}
                buttonTextLeading="Join the Beta"
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  componentDidMount() {
    // Hackish way to ensure CTA Banner doesn't appear
    // upon initial page load
    setTimeout(() => {
      this.setState({ shouldAllowCTABannerToMount: true });
    }, 1000);
  }

  handleVizVideoSection = (isVizVideoSection) => {
    this.setState({ isVizVideoSection: isVizVideoSection });
  };

  handleOpenTrailerVideo = () => {
    // window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.body.style.overflow = "hidden";
    this.setState({ isTrailerVideoOpen: true });
  };
  handleCloseTrailerVideo = () => {
    document.body.style.overflow = "unset";
    this.setState({ isTrailerVideoOpen: false });
  };

  handleVizFooter = (isVisible) => {
    this.setState({ isFooterVisible: isVisible });
  };

  handleVizHeroCTA = (isVisible) => {
    this.setState({ isHeroCTAVisible: isVisible });
  };

  scrollToTop = () => {
    window.scrollTo({ top: 0 });
  };
}

export default (props) => {
  const { isModalBetaSignupVisible, showModalBetaSignup, hideModalBetaSignup } =
    useContext(ModalBetaSignupContext);

  return (
    <MarketingLanding
      {...props}
      context={{
        isModalBetaSignupVisible,
        showModalBetaSignup,
        hideModalBetaSignup,
      }}
    />
  );
};
